import React, {useEffect, useState} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../style/NavBar.css";
import Image from "../assets/sitting.png";

const NavBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    const [showNavbar, setShowNavbar] = useState(true);

    const getBackRoute = () => {
        const currentPath = location.pathname;

        if (currentPath.startsWith("/about/")) {
            return "/about";
        } else if (currentPath.startsWith("/work/")) {
            return "/work";
        } else if (currentPath.startsWith("/activities/")) {
            return "/activities";
        } else if (currentPath.startsWith("/contact/")) {
            return "/contact";
        } else if (currentPath === "/contact") {
            return "/";
        } else {
            return "/";
        }
    };

    const handleNavbarClick = (e) => {
        if (e.target.closest(".nav-item")) {
            return;
        }
        const backRoute = getBackRoute();
        if (backRoute && backRoute !== location.pathname) {
            navigate(backRoute);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile && location.pathname !== "/") {
            setShowNavbar(false);
        } else {
            setShowNavbar(true);
        }
    }, [location.pathname, isMobile]);

    const handleReturnClick = () => {
        const isWorkPage = location.pathname === "/work";
        const sideMenuOpen = document.querySelector(".side-menu");

        if (isWorkPage && sideMenuOpen) {
            document.querySelector(".return-button.work-return")?.click();
        } else {
            navigate(getBackRoute());
            setShowNavbar(true);
        }
    };



    return (
        <div>
            <div className={`logo-container ${location.pathname !== "/" ? "hidden" : ""}`}>
                <motion.div
                    className="logo-motion"
                    initial={{ opacity: 1, x: 0 }}
                    animate={{ opacity: location.pathname === "/" ? 1 : 0 }}
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                >
                    <h1 className="logo-text">
                        <span className="letter">D</span>
                        <span className="letter">A</span>
                        <span className="letter">N</span>
                        <span className="letter">C</span>
                        <span className="letter">E</span>
                        <span className="letter">R</span>
                        <span className="letter">&nbsp;</span>
                        <span className="letter">B</span>
                        <span className="letter">O</span>
                        <span className="letter">Y</span>
                        <span className="letter">&nbsp;</span>
                        <span className="letter">S</span>
                        <span className="letter">M</span>
                        <span className="letter">I</span>
                        <span className="letter">T</span>
                        <span className="letter">H</span>
                    </h1>

                    <img src={Image} alt="Stylized character" className="logo-image" />
                </motion.div>
            </div>


            <div>
                {/* Return Button (Mobile Only) */}
                {isMobile && !showNavbar && (
                    <button className="return-button" onClick={handleReturnClick}>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>
                )}

                {/* Full Navbar (Hidden on Mobile After Navigation) */}
                {!isMobile || showNavbar ? (
                    <div
                        className={`nav ${location.pathname !== "/" ? "back-cursor" : ""}`}
                        onClick={handleNavbarClick}
                    >
                        <div className={`nav-links ${location.pathname === "/" ? "large-nav" : "small-nav"}`}>
                            <div className="nav-item">
                                <Link className={`nav-link ${location.pathname.startsWith("/activities") ? "active-nav" : ""}`} to="/activities">
                                    ACTIVITIES
                                </Link>
                            </div>
                            <div className="nav-item">
                                <Link className={`nav-link ${location.pathname.startsWith("/work") ? "active-nav" : ""}`} to="/work">
                                    Work
                                </Link>
                            </div>
                            <div className="nav-item">
                                <a
                                    className={`nav-link`}
                                    href="https://shop.dancerboysmith.com"
                                >
                                    Shop
                                </a>
                            </div>
                            <div className="nav-item">
                                <Link className={`nav-link ${location.pathname.startsWith("/about") ? "active-nav" : ""}`} to="/about">
                                    About
                                </Link>
                            </div>
                            <div className="nav-item">
                                <Link className={`nav-link ${location.pathname.startsWith("/contact") ? "active-nav" : ""}`} to="/contact">
                                    Contact
                                </Link>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>

        </div>
    );
};

export default NavBar;
